import { importModuleAndRenderNotification } from '../helpers/renderHelpers';

function importTradeDesignManagerOnboardingModal() {
    return import(
        /* webpackChunkName: "TradeDesignManagerOnboardingModalChunk" */
        './TradeDesignManagerOnboardingModal'
    ).then(moduleExport => moduleExport.TradeDesignManagerOnboardingModal);
}

export const launchTradeDesignManagerOnboarding = ({ customActionType }) => dispatch => {
    importModuleAndRenderNotification({
        importFunc: importTradeDesignManagerOnboardingModal,
        containerClassName: 'tradeDesignManagerOnboardingContainer',
    });

    return dispatch({ type: customActionType.actionType });
};
